import firebaseApp from '../../../../services/firebaseService';
import { BasicBaseHelper, IBasicBaseClass } from '../../base';

export interface IPumpingStationMotorMounting extends IBasicBaseClass {
    name : string;

    isActive : boolean;
}

export default class PumpingStationMotorMountingHelper extends BasicBaseHelper {
    public static readonly COLLECTION_NAME = 'pumping_station_motor_mounting';

    private static converter : firebase.firestore.FirestoreDataConverter<IPumpingStationMotorMounting> = {
        fromFirestore: (snapshot) => {
            return PumpingStationMotorMountingHelper.fromFirestoreDocument(snapshot);
        },
        toFirestore: (data : IPumpingStationMotorMounting) : firebase.firestore.DocumentData => {
            return PumpingStationMotorMountingHelper.toFirestoreDocument(data);
        },
    };

    public static fromFirestoreDocument(snapshot : firebase.firestore.DocumentSnapshot) : IPumpingStationMotorMounting {
        const result = super.fromFirestore(snapshot);
        const data = snapshot.data();

        if (!snapshot.exists || !result || !data) throw new Error(`Document does not exist! ${snapshot.id}`);
        return {
            ...data as IPumpingStationMotorMounting,
            ...result,
        };
    }

    public static toFirestoreDocument(data : IPumpingStationMotorMounting) {
        const result = super.toFirestore(data);
        const { id: _id, ...rest } = data;

        return {
            ...rest,
            ...result,
        };
    }

    public static doc(id ?: string) {
        if (!id) {
            return firebaseApp.firestore().collection(PumpingStationMotorMountingHelper.COLLECTION_NAME).withConverter(PumpingStationMotorMountingHelper.converter).doc();
        }

        return firebaseApp.firestore().collection(PumpingStationMotorMountingHelper.COLLECTION_NAME).withConverter(PumpingStationMotorMountingHelper.converter).doc(id);
    }

    public static save(company : IPumpingStationMotorMounting) {
        return PumpingStationMotorMountingHelper.doc(company.id).set(company, {
            merge: true,
        });
    }
    
    public static collection() {
        return firebaseApp
            .firestore()
            .collection(PumpingStationMotorMountingHelper.COLLECTION_NAME)
            .withConverter(PumpingStationMotorMountingHelper.converter);
    }
}